import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as messageStatus from '../message-status'

export const RESOURCE = {
  payload: {
    description: 'Message processing completed successfully',
    enumId: core.dms.models.Enum.Id.from({
      partialId: messageStatus.RESOURCE.payload.partialId,
    }),
    id: 'completed',
    name: 'Completed',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
